export default global.localStorage
